import React, { useState, useRef } from "react";
import { useSpring } from "react-spring";

import { colorPalette } from "../../Config/colorConfig.js";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleDown } from "@fortawesome/free-solid-svg-icons";

//RWD: 1300 & 1000
import { CloseButton } from "../../Config/generalButton.js";

import {
  Content,
  TitleWrapper,
  TitleLogoImg,
  Title,
  YellowWrapper,
  YellowImg,
  InsideWrapper,
} from "./CardStyle";

import { cardLogo, yellowBlock } from "../../Config/cardConfig.js";

import MachineCard from "./machineCard.js";
import ShowroomCard from "./showroomCard.js";
import SituationroomCard from "./situationroomCard.js";
import SmartautomationCard from "./smartautomationCard.js";
import {
  SMObjectives,
  SMSmartAutomation,
  SMSmartMachines,
  SMSmartManagement,
  SMSmartService,
} from "./smartmanufacturingCard.js";

import { machineConfig } from "../../data/machine.js";
import showroomConfig from "../../data/showroom.js";
import situationroomConfig from "../../data/situationroom.js";
import smartAutomationConfig from "../../data/smartAutomation.js";
import smartManufacturingConfig from "../../data/smartManufacturing.js";

const Card = (props) => {
  const {
    isMobile,
    setLookAtCard,
    cardType,
    cardContent,
    setCardContent,
    langCh,
  } = props;

  const contentRef = useRef(null);

  const [scrollTop, setScrollTop] = useState(0); //for ios sticky close button
  const [clientHeight, setClientHeight] = useState(0);

  const [onPlay, setOnPlay] = useState(false); //for video

  const { width, height } = useSpring({
    from: { width: "0%", height: "0%" },
    width: "70%",
    height: "80%",
    config: { mass: 1, tension: 280, friction: 60 },
  });

  const closeHandler = () => {
    setLookAtCard((c) => !c);
    setOnPlay(false);
  };

  return (
    <Content
      ref={contentRef}
      style={{ width, height }}
      onScroll={() => {
        setScrollTop(contentRef.current.scrollTop);
      }} //for close button
      onMouseOver={() => {
        setClientHeight(contentRef.current.clientHeight);
      }}
    >
      <CloseButton
        handler={closeHandler}
        style={{ top: scrollTop + 10, right: "10px" }}
      />

      {!isMobile && (
        <FontAwesomeIcon
          style={{
            top: scrollTop + clientHeight - 55,
            right: "10px",
            color: colorPalette.myYellow,
            position: "absolute",
            zIndex: 500,
          }}
          icon={faAngleDoubleDown}
          size="3x"
        />
      )}

      <TitleWrapper>
        <TitleLogoImg style={{ backgroundImage: `url(${cardLogo})` }} />
        {cardType === "machine" && (
          <Title langCh={false}>
            {machineConfig[cardContent][langCh ? "ch" : "en"].title}
          </Title>
        )}
        {cardType === "showroom" && (
          <Title langCh={langCh}>
            {showroomConfig[cardContent][langCh ? "ch" : "en"].title}
          </Title>
        )}
        {cardType === "situationroom" && (
          <Title langCh={langCh}>
            {situationroomConfig[langCh ? "ch" : "en"].title}
          </Title>
        )}
        {cardType === "smartautomation" && (
          <Title langCh={langCh}>
            {smartAutomationConfig[langCh ? "ch" : "en"].title}
          </Title>
        )}
        {cardType === "smartManufacturing" && (
          <Title langCh={langCh} smallFont>
            {smartManufacturingConfig[cardContent][langCh ? "ch" : "en"].title}
          </Title>
        )}
      </TitleWrapper>
      <YellowWrapper>
        <YellowImg style={{ backgroundImage: `url(${yellowBlock})` }} />
      </YellowWrapper>

      <InsideWrapper>
        {/*machine*/}
        {cardType === "machine" && (
          <MachineCard
            contentRef={contentRef}
            cardContent={cardContent}
            onPlay={onPlay}
            setOnPlay={setOnPlay}
            langCh={langCh}
          />
        )}
        {/*showroom*/}
        {cardType === "showroom" && (
          <ShowroomCard cardContent={cardContent} langCh={langCh} />
        )}
        {/*situationroom*/}
        {cardType === "situationroom" && <SituationroomCard langCh={langCh} />}
        {/*smartautomation*/}
        {cardType === "smartautomation" && (
          <SmartautomationCard langCh={langCh} />
        )}

        {/*smartManufacturing*/}
        {cardType === "smartManufacturing" &&
          cardContent === "SMObjectives" && (
            <SMObjectives
              contentRef={contentRef}
              langCh={langCh}
              onPlay={onPlay}
              setOnPlay={setOnPlay}
              cardContent={cardContent}
              setCardContent={setCardContent}
            />
          )}
        {cardType === "smartManufacturing" &&
          cardContent === "SMSmartAutomation" && (
            <SMSmartAutomation
              langCh={langCh}
              cardContent={cardContent}
              setCardContent={setCardContent}
            />
          )}
        {cardType === "smartManufacturing" &&
          cardContent === "SMSmartMachines" && (
            <SMSmartMachines
              langCh={langCh}
              cardContent={cardContent}
              setCardContent={setCardContent}
            />
          )}
        {cardType === "smartManufacturing" &&
          cardContent === "SMSmartManagement" && (
            <SMSmartManagement
              langCh={langCh}
              cardContent={cardContent}
              setCardContent={setCardContent}
            />
          )}
        {cardType === "smartManufacturing" &&
          cardContent === "SMSmartService" && (
            <SMSmartService
              langCh={langCh}
              cardContent={cardContent}
              setCardContent={setCardContent}
            />
          )}
      </InsideWrapper>
    </Content>
  );
};

export default Card;
